import React from "react";

const EditStudentToClassIcon = () => {
  return (
      <svg viewBox="0 0 17.574 16.319">
          <g transform="translate(-15.789 -31.578)">
              <path data-name="Path 359" d="M29.911,31.578l-3.452,3.138h1.883v5.021a.629.629,0,0,1-.628.628H22.066V43.5h5.649a3.767,3.767,0,0,0,3.766-3.766V34.716h1.883Zm-9.1,4.394a3.138,3.138,0,0,0-3.138,3.138v5.649H15.789L19.241,47.9l3.452-3.138H20.81V39.738a.629.629,0,0,1,.628-.628h5.649V35.972Z"></path>
          </g>
      </svg>
  );
};

export default EditStudentToClassIcon;
